module.exports = __webpack_public_path__ + "static/testimonial-thumb-4-748fdc74d32e775b7a3dac2386b34ff4.jpg";